import { useState, useEffect } from "react";
import React from 'react';
import { format, parseISO } from "date-fns";
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography, IconButton, CircularProgress } from "@mui/material";
import Header from "../../components/Header";
import apiService from "../../service/apiService";
import "react-datepicker/dist/react-datepicker.css";
import { FaEye, FaRegEdit, FaTrash } from "react-icons/fa";
import { Pagination, Table } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { IMG_URL } from "../../service/ImageUrl";
import { Download, ZoomIn } from "@mui/icons-material";
import { saveAs } from 'file-saver'
import CloseIcon from "@mui/icons-material/Close";

const Farmerdata = () => {
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1); 
  const [rowCount, setRowCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState({ producerGroupId: '', phoneNumber: '', casteId: '', farmerClassId: '' });
  const [category, setCategory] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [longitude, setLongitude] = useState("");
  const [latitude, setLatitude] = useState("");
  const [location, setLocation] = useState("");
  const [images, setImages] = useState("");
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false); 
  const [totalItems, setTotalitems] = useState(0);
  const [totalpage, setTotalpage] = useState(0);
  const [imagesToShow, setImagesToShow] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [fullscreenImage, setFullscreenImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState("");

  const handleNext = () => {
    if (activeIndex < imagesToShow.imageVerificationDocumentList.length - 1) {
      setActiveIndex(activeIndex + 1);
    }
  };

  const handlePrev = () => {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }
  };

  const handleDownload = () => {
    if (imagesToShow.imageVerificationDocumentList.length > 0) {
      const currentImage = imagesToShow.imageVerificationDocumentList[activeIndex].imageUrl;
      const imageUrl = IMG_URL + currentImage;
      saveAs(imageUrl, `image-${activeIndex + 1}.jpg`);
    }
  };
  const fetchData = async () => {
    try {
      const response = await apiService.post("/image-verification/get-image-verification-index", {
        location,
        pageNumber: page,
        pageSize: pageSize,
        description: description,
        reason:"",
        seasonName: "",
        verificationType: category,
        date: date ? date : null,
      });

      if (response.data.status && response.data.body && response.data.body.data) {
        const data = response.data.body.data;
        setTotalitems(response.data.body.totalRecordsCount);
        setTotalpage(response.data.body.totalPages);
        setRows(data);
        setRowCount(response.data.body.recordsCount);
      } else {
        setTotalitems(0);
        setTotalpage(0);
        setRows([]);
        console.error("Invalid response structure:", response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, pageSize, category, date, time, longitude, latitude, location, images, description]);


  const handleView = async (data) => {
    try {
      const response = await apiService.get(`image-verification/get/${data.imageVerificationId}`);
      if (response.data.status && response.data.body) {
        setImagesToShow(response.data.body); 
        // setShowImageDialog(true);
        // console.log("immage to show", response.data.body );
        setOpen(true);
      } else {
        console.error("Invalid response structure:", response.data);
      }
    } catch (error) {
      console.error("Error fetching images:", error);
    }
  };
  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
    setActiveIndex(0);
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const startItem = (page - 1) * 10 + 1;
  const endItem = Math.min(page * 10, totalItems);

  const renderPaginationItems = () => {
    const paginationItems = [];
    const maxPagesToShow = 7;
    const startPages = 3;
    const endPages = 2;

    if (totalpage <= maxPagesToShow) {
      for (let pages = 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    } else {
      // Show first 3 pages
      for (let pages = 1; pages <= startPages; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      // Show ellipsis if necessary
      if (page > startPages + 1) {
        paginationItems.push(<Pagination.Ellipsis key="start-ellipsis" />);
      }

      // Show the middle pages around the current page
      const middlePages = [];
      const startMiddlePage = Math.max(page - 1, startPages + 1);
      const endMiddlePage = Math.min(page + 1, totalpage - endPages);

      for (let pages = startMiddlePage; pages <= endMiddlePage; pages++) {
        middlePages.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      paginationItems.push(...middlePages);

      // Show ellipsis if necessary
      if (page < totalpage - endPages - 1) {
        paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" />);
      }

      // Show last 2 pages
      for (let pages = totalpage - endPages + 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    }
    return paginationItems;
  };

  const handleVerify = async (mapid) => {
    setLoading(true); // Start loading
    try {
        const payload = { mappingIds: [mapid] };
        const response = await apiService.put("/image-verification/verify", payload);

        if (response.data.status) {
            console.log("Verification successful:", response.data);
            setImagesToShow((prevState) => {
              const updatedImages = [...prevState.imageVerificationDocumentList];
              updatedImages[activeIndex] = { 
                ...updatedImages[activeIndex], 
                isVerified: true 
              };

              return { ...prevState, imageVerificationDocumentList: updatedImages };
            });
        } else {
            console.error("Verification failed:", response.data);
        }
    } catch (error) {
        console.error("Error verifying image:", error);
    } finally {
        setLoading(false); // Stop loading after success/failure
    }
  };
  return (
    <div className="container-fluid" style={{ maxHeight: "100vh", overflowX: "auto", scrollbarWidth: "thin", scrollbarColor: "#ccc transparent"  }}>
        <div className="row">
        <div className="d-flex justify-content-between align-items-center">
          <Header title="Image Details" />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body table-responsive p-0" 
            style={{
              minHeight: "60vh",
              overflowX: "auto",
              scrollbarWidth: "thin", 
              scrollbarColor: "#ccc transparent", 
            }}>
              <table className="table table-hover table-bordered text-nowrap mb-0">
            <thead>
              <tr>
                {/* Other headers */}
                <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                  Category
                  <br />
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm"
                    value={category}
                    onChange={(e) => {
                      setCategory(e.target.value);
                      setPage(1);
                    }}
                    style={{ minWidth: "100px" }}
                  />
                </th>
                <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                  Date
                  <br />
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    value={date}
                    onChange={(e) => {
                      setDate(e.target.value);
                      setPage(1);
                    }}
                    style={{ minWidth: "100px" }}
                  />
                </th>
                <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                  Longitude
                  <br />
                  {/* <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm"
                    value={longitude}
                    onChange={(e) => {
                      setLongitude(e.target.value);
                      setPage(1);
                    }}
                    style={{ minWidth: "100px" }}
                  /> */}
                </th>
                <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                  Latitude
                  <br />
                  {/* <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm"
                    value={latitude}
                    onChange={(e) => {
                      setLatitude(e.target.value);
                      setPage(1);
                    }}
                    style={{ minWidth: "100px" }}
                  /> */}
                </th>
                <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                  Location
                  <br />
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm"
                    value={location}
                    onChange={(e) => {
                      setLocation(e.target.value);
                      setPage(1);
                    }}
                    style={{ minWidth: "100px" }}
                  />
                </th>
                <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                  Description
                  <br />
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm"
                    value={description}
                    onChange={(e) => {
                      setDescription(e.target.value);
                      setPage(1);
                    }}
                    style={{ minWidth: "100px" }}
                  />
                </th>
                <th className="py-2 align-middle">Action</th>

              </tr>
            </thead>
            <tbody style={{ fontSize: "14px" }}>
              {rows.map((data, index) => (
                <tr key={index}>
                  <td className="py-0 align-middle">{data.verificationType}</td>
                  <td className="py-0 align-middle">{data.date ? format(parseISO(data.date), "dd-MM-yyyy") : "N/A"}</td>
                  <td className="py-0 align-middle">{data.longitude}</td>
                  <td className="py-0 align-middle">{data.latitude}</td>
                  <td className="py-0 align-middle">{data.location}</td>
                  <td className="py-0 align-middle" style={{ width: '300px', padding: '5px' }}>
                    <div 
                      style={{
                        maxHeight: '5em', 
                        overflowY: 'auto', 
                        wordWrap: 'break-word',
                        whiteSpace: 'normal'
                      }}
                    >
                      {data.description}
                    </div>
                  </td>
                  <td className="d-flex  p-0">
                    <button className="btn btn-md" onClick={() => handleView(data)} title="View">
                      <FaEye />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
            </table>

            </div>
          </div>
        </div>
      </div>


      <div className="row mt-3">
        <div className='d-flex justify-content-between pb-0'>
          <div className='p-1'>
            Showing {startItem} to {endItem} of {totalItems} items
          </div>
          <div className='p-1'>
            <Pagination className="mb-0">
              <Pagination.First onClick={() => handlePageChange(1)} disabled={page === 1} />
              <Pagination.Prev onClick={() => handlePageChange(page - 1)} disabled={page === 1} />
              {renderPaginationItems()}
              <Pagination.Next onClick={() => handlePageChange(page + 1)} disabled={page === totalpage} />
              <Pagination.Last onClick={() => handlePageChange(totalpage)} disabled={page === totalpage} />
            </Pagination>
          </div>
        </div>
      </div>

      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <div className="d-flex justify-content-between">
          <DialogTitle>Image Verification</DialogTitle>
          <DialogActions>
          <IconButton onClick={handleClose} style={{ color: "red" }}>
            <CloseIcon />
          </IconButton>
        </DialogActions>
        </div>
        <DialogContent>
        {imagesToShow?.imageVerificationDocumentList?.length > 0 && (
      <Box className="d-flex flex-column align-items-center">
        <Typography variant="subtitle1" className="text-secondary fw-bold mb-2">
          Images:
        </Typography>
        <div className="w-100 d-flex justify-content-end mb-2">
         
          <IconButton onClick={handleDownload} style={{ backgroundColor: "rgba(0,0,0,0.7)", color: "white", marginRight: "10px" }}>
            <Download />
          </IconButton>

          <IconButton
            onClick={() => setFullscreenImage(IMG_URL + imagesToShow.imageVerificationDocumentList[activeIndex]?.imageUrl)}
            style={{ backgroundColor: "rgba(0,0,0,0.7)", color: "white" }}
          >
            <ZoomIn />
          </IconButton>
        </div>

        
        <div className="w-100 text-center">
          <img
            src={IMG_URL + imagesToShow.imageVerificationDocumentList[activeIndex]?.imageUrl}
            className="d-block mx-auto"
            style={{ height: "400px", width: "400px", objectFit: "contain" }}
            alt={`Image ${activeIndex + 1}`}
          />
        </div>

        <div className="d-flex justify-content-between w-100 mt-3">
          <Button onClick={handlePrev} disabled={activeIndex === 0} variant="contained">
            Previous
          </Button>
          {imagesToShow.imageVerificationDocumentList[activeIndex]?.isVerified ? (
              <div className="pt-2 text-success"> Verified </div>
            ) : (
              <Button 
                onClick={() => handleVerify(imagesToShow.imageVerificationDocumentList[activeIndex]?.mappingId)} 
                variant="contained" 
                disabled={loading} // Disable button when loading
              >
                {loading ? <CircularProgress size={24} color="inherit" /> : "Verify"}
              </Button>
            )}
          <Button onClick={handleNext} disabled={activeIndex === imagesToShow.imageVerificationDocumentList.length - 1} variant="contained">
            Next
          </Button>
        </div>
      </Box>
    )}

        </DialogContent>
      
      </Dialog>
      {/* Fullscreen Image Dialog */}
      {fullscreenImage && (
        <Dialog open={Boolean(fullscreenImage)} onClose={() => setFullscreenImage(null)} maxWidth="lg" fullWidth>
          <DialogTitle>
            <IconButton 
              onClick={() => setFullscreenImage(null)} 
              style={{ position: "absolute", right: 10, top: 0, color: "red" }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <img src={fullscreenImage} alt="Fullscreen" className="d-block mx-auto" style={{ width: "100%", height: "auto" }} />
          </DialogContent>
        </Dialog>
      )}
  </div>
  );
};

export default Farmerdata;
